// extracted by mini-css-extract-plugin
module.exports = {"card":"RewardPageModuleWrapperPreset__card__YumVP"};